<template>
    <BaseDialog
        :showDialog="confirmationDialog.show"
        maxDialogWidth="500"
        maxCardHeight="500"
        :headline="headlineTitle"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t('lang_GENERIC_DIALOG_TEXT_ACTION_ON_RESULTS') }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-model="userInput"
                            :messages="$t(errorMessage)"
                            depressed
                            @keydown.enter="checkUserInput()"
                            class="ml-0 mr-0"
                            :label="confirmationValue"
                            :alvqa="alvqa + '-textfield-confirm'"
                            autofocus
                        ></v-text-field>
                    </v-col>
                    <v-col class="text-right" align-self="center">
                        <BaseButton
                            @click="checkUserInput()"
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa + '-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
        
    </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

import { mapState } from 'vuex'

export default {
    name: "ConfirmationDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    data() {
        return {
            context: "ConfirmationDialog",
            userInput: '',
            errorMessage: '',
            alvqa: "confirmation-dialog",
            resolveCallback: null 
        }
    },
    computed: {
        ...mapState(['confirmationDialog']),
        confirmationValue(){
            return this.$store.getters.getTotalListed.toString()
        },
        headlineTitle(){
            let title = this.$t('lang_GENERIC_DIALOG_TITLE_WARNING_ACTION_ON_RESULTS')
            return title.replace("{REPLACE_1}", this.confirmationValue)
        }
    },
    methods: {
        checkUserInput(){
            /**
             * Converting userInput and confirmationValue to INT values,
             * Javascript before multiplication (*) tries to convert string to int, if can't convert that value will be NaN
             */ 
            let userInput = this.userInput * 1 
            let confirmationValue = this.confirmationValue * 1
            if(userInput === confirmationValue){
                this.userInput = ''
                this.errorMessage = ''
                this.$store.dispatch('resolveConfirmationDialog')
            }else{
                this.errorMessage = 'lang_GENERIC_DIALOG_ERROR_MESSAGE_WRONG_VALUE'
            }
        },
        closeDialog(){
            this.$store.commit('setResolveCallbackConfirmationDialog', false)
            this.$store.commit('setConfirmationDialog', { show: false, txt: '', result: false, resolveCallback: null })
            this.userInput = ''
            this.errorMessage = ''
        }
    }
}
</script>